// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__ewyWz","main":"styles_main__NgTls"};